import { FC } from 'react';
import { BiMessageDetail } from 'react-icons/bi';

import Tooltip from '@/ux-legacy/components/common/Tooltip/Tooltip';

type MessagingButtonProps = {
  count?: number;
  invertColors?: boolean;
  onClick: () => void;
  showMessageChat?: boolean;
};

const MessagingButton: FC<MessagingButtonProps> = ({
  count,
  onClick,
  invertColors = false,
  showMessageChat = true,
}) => {
  return (
    <Tooltip text={'Message'}>
      <button
        onClick={onClick}
        disabled={!showMessageChat}
        className={`w-9 h-9 p-2 flex justify-center items-center rounded-full ${
          invertColors
            ? 'bg-gray-200 dark:bg-slate-700 hover:bg-gray-300 dark:hover:bg-slate-500'
            : 'bg-[#323232]'
        }   relative`}
      >
        {showMessageChat && (
          <>
            {count ? (
              <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4">
                <span className="w-5 h-5 text-xs flex bg-red-500 rounded-full items-center justify-center text-white">
                  <span>{Math.min(99, count)}</span>
                  {count > 99 ? <span>+</span> : <></>}
                </span>
              </div>
            ) : (
              <></>
            )}
            <BiMessageDetail
              className={`w-full h-full ${invertColors ? 'text-[#323232]' : 'text-white'} mt-0.5`}
            />
          </>
        )}
      </button>
    </Tooltip>
  );
};

export default MessagingButton;
